import { UseQueryResult } from '@tanstack/react-query';
import { useTrackedQuery as useQuery } from '@ais-ui/performance-tracking';

import { useSession } from '../SessionProvider';
import {
  AutoCompleteDBShipInfo,
  autocompleteDBShips,
} from './autocompleteShips';

export const useAutocompleteDbShips = (
  searchstring: string
): UseQueryResult<AutoCompleteDBShipInfo[] | null> => {
  const { dbSession } = useSession();

  return useQuery({
    queryKey: ['autocompleteDBShips', searchstring],
    queryFn: () => {
      // Early return if no dbSession
      if (!dbSession) {
        console.error('no dbSession');
        return Promise.resolve(null);
      }

      // Early return if searchstring is too short
      if (!searchstring || searchstring.length < 3) {
        return Promise.resolve(null);
      }

      return autocompleteDBShips(dbSession, searchstring);
    },
    // Disable the query if the search string is too short
    enabled: !!dbSession && searchstring.length >= 3,
    // Optional: you might want to clear old results when the search string becomes too short
    placeholderData: null,
  }, 'dbShips:autocomplete');
};
